import { tv } from '@/ui/utils'

/**
 * Body text, in Maison Neue Book with Bold for emphasis, at the Style Library's three sizes.
 *
 * `body1` (14/18) is the default and what most copy is. `body2` (12/16) is captions, helper
 * lines and legal. `body3` (10/10, bold, uppercase) is a micro-label and nothing else.
 *
 * The old `size` and `weight` names are kept as aliases onto the brand sizes so existing screens
 * keep rendering while they are moved over; they are retired with the last migration.
 */
export const typographyStyles = tv({
	base: 'text-ink web:select-text',
	variants: {
		size: {
			body0: 'text-body0',
			body1: 'text-body1',
			body2: 'text-body2',
			body3: 'text-body3 uppercase',
			// Aliases, to be retired.
			xs: 'text-body2',
			small: 'text-body1',
			medium: 'text-body1',
			large: 'text-body0',
			xl: 'text-body0',
			'2xl': 'text-body0',
		},
		weight: {
			book: 'font-body',
			bold: 'font-bold',
			// Aliases, to be retired.
			light: 'font-body',
			medium: 'font-body',
		},
		tone: {
			ink: 'text-ink',
			white: 'text-white',
			muted: 'text-muted',
			soft: 'text-softInk',
			danger: 'text-danger',
		},
		underlined: {
			true: 'underline underline-offset-4',
		},
		spacing: {
			normal: 'tracking-normal',
			wide: 'tracking-[.15em]',
		},
	},
	compoundVariants: [{ size: 'body3', class: 'font-bold' }],
	defaultVariants: {
		size: 'body1',
		weight: 'book',
		tone: 'ink',
		spacing: 'normal',
	},
})
